(function () {
  var STORAGE_KEY = 'recentlyViewedProducts';
  var MAX_ITEMS = 10;

  function getProductHandle() {
    var main = document.querySelector('main[data-template]');
    if (!main || main.dataset.template !== 'product') return null;

    var canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) return null;

    var match = canonical.href.match(/\/products\/([a-zA-Z0-9\-_%]+)/);
    return match ? decodeURIComponent(match[1]) : null;
  }

  function saveToRecentlyViewed(handle) {
    if (!handle) return;

    var handles = [];
    try {
      handles = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      handles = [];
    }

    if (!Array.isArray(handles)) handles = [];

    // Same product dobara viewed ho to usay top pe le aao, duplicate na banao
    handles = handles.filter(function (h) { return h !== handle; });
    handles.unshift(handle);
    handles = handles.slice(0, MAX_ITEMS);

    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles));
    } catch (e) {
      // localStorage full ya disabled — silently ignore
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var handle = getProductHandle();
    if (handle) saveToRecentlyViewed(handle);
  });
})();